import { Engine, ImageSource } from 'excalibur';
import { outline } from './outline.shader';
import { ShockWavePostProcessor } from './shockwave.shader';
import { perspective } from './perspective.shader';
import { rotatedPerspective } from './rotatedPerspective.shader';

export { ShockWavePostProcessor };

export enum Shaders {
  OUTLINE = 'outline',
  PERSPECTIVE = 'perspective',
  ROTATED_PERSPECTIVE = 'rotatedPerspective',
}

const shaders: Record<Shaders, string> = {
  outline,
  perspective,
  rotatedPerspective,
};

export const getMaterial = (
  game: Engine,
  name: Shaders,
  image?: ImageSource
) => {
  return game.graphicsContext.createMaterial({
    name,
    fragmentSource: shaders[name],
    images: image
      ? {
          u_graphic2: image,
        }
      : undefined,
  });
};
